import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Stepper, {
    Step,
    StepButton,
    StepContent,
    StepLabel,
} from 'material-ui/Stepper';
import Typography from 'material-ui/Typography';
import { CircularProgress } from 'material-ui/Progress';
import DrawerContainer from '../FormStepper/Drawer/DrawerContainer';
import QuickQuoteContainer from './QuickQuote/QuickQuoteContainer';
import SampleProductsContainer from './SampleProducts/SampleProductsContainer';
import ApplicantDetailsContainer from './ApplicantDetails/ApplicantDetailsContainer';
import RegisterContainer from './Register/RegisterContainer';
import SoftCheckContainer from './SoftCheck/SoftCheckContainer';
import ApplicantDetailsSummaryContainer from './ApplicantDetailsSummary/ApplicantDetailsSummaryContainer';
import ApplicantIdVerificationContainer from './ApplicantIdVerification/ApplicantIdVerificationContainer';
import PropertyDetailsContainer from './PropertyDetails/PropertyDetailsContainer';
import SelectBestOfferContainer from './SelectBestOffer/SelectBestOfferContainer';
import UnderWrittingSummaryContainer from './UnderwrittingSummary/UnderWrittingSummaryContainer';
import colors from '../../config/themeColors';

const styles = theme => ({
    root: {
        display: 'flex',
        width: '100%',
        paddingLeft: 0,
        [theme.breakpoints.up('md')]: {
            paddingLeft: '28px',
            maxWidth: 'calc(100% - 28px)',
        },
    },
    stepper: {
        width: '100%',
        pading: 32,
    },
    button: {
        justifyContent: 'left',
        width: 'auto',
    },
    stepContent: {
        backgroundColor: colors.white3,
        borderColor: colors.white2,
    },
    stepDesc: {
        textAlign: 'left',
        fontSize: '12px',
        color: colors.warmGrey,
    },
    label: {
        color: colors.warmGrey,
        marginLeft: '16px',
        textAlign: 'left',
    },
    labelActive: {
        color: colors.bloodOrange,
        textAlign: 'left',
    },
    labelDisabled: {
        color: colors.brownishGrey,
        textAlign: 'left',
    },
    labelCompleted: {
        color: colors.bloodOrange,
        marginLeft: '16px',
        textAlign: 'left',
    },
    connector: {
        borderLeft: `1px solid ${colors.white2}`,
        marginLeft: '12px',
    },
});

// const steps = [
//     {
//         label: 'Mortgage Details',
//         subLabel: 'Optional',
//         disabled: [],
//     },
//     {
//         label: 'Sample Products',
//         subLabel: 'Optional',
//         disabled: [0],
//     },
//     {
//         label: 'Register / Login to SGL Fintech Account',
//         subLabel: 'Optional',
//         disabled: [],
//     },
//     {
//         label: 'Applicant Details',
//         subLabel: 'Optional',
//         disabled: [2],
//     },
//     {
//         label: 'Soft credit check',
//         subLabel: 'Optional',
//         disabled: [1, 3],
//     },
//     {
//         label: 'Mortgage Calculation Summary',
//         subLabel: 'Optional',
//         disabled: [4],
//     },
//     {
//         label: 'Applicant identity verification',
//         subLabel: 'Optional',
//         disabled: [3],
//     },
//     {
//         label: 'Property details',
//         subLabel: 'Optional',
//         disabled: [],
//     },
//     {
//         label: 'Underwriting Summary',
//         subLabel: 'Optional',
//         disabled: [8],
//     },
// ];

function FormStepper(props) {
    const labelClasses = {
        label: props.classes.label,
        labelActive: props.classes.labelActive,
        disabled: props.classes.labelDisabled,
        labelCompleted: props.classes.labelCompleted,
    };
    return props.isPending
        ? (
            <div
                className={props.classes.root}
            >
                <CircularProgress />
            </div>
        )
        : (
            <div
                className={props.classes.root}
            >
                <Stepper
                    activeStep={props.activeStep}
                    orientation="vertical"
                    nonLinear
                    className={props.classes.stepper}
                    connector={<div className={props.classes.connector}>&nbsp;</div>}
                >
                    <Step>
                        <StepButton
                            className={props.classes.button}
                            onClick={() => {
                                props.setStep(0);
                            }}
                            completed={props.steps[0].completed}
                            disabled={props.activeStep === 0}
                        >
                            <StepLabel
                                classes={labelClasses}
                            >
                                Mortgage Details
                                <Typography className={props.classes.stepDesc}>Optional</Typography>
                            </StepLabel>
                        </StepButton>
                        <StepContent className={props.classes.stepContent}>
                            <QuickQuoteContainer
                                steps={props.steps}
                                setStep={props.setStep}
                                setStepCompleted={props.setStepCompleted}
                                setStepsUncompleted={props.setStepsUncompleted}
                                setApplicationId={props.setApplicationId}
                            />
                        </StepContent>
                    </Step>
                    <Step>
                        <StepButton
                            className={props.classes.button}
                            onClick={() => props.setStep(1)}
                            completed={props.steps[1].completed}
                            disabled={props.activeStep === 1 || !props.steps[0].completed}
                        >
                            <StepLabel
                                classes={labelClasses}
                            >
                                Sample Products
                                <Typography className={props.classes.stepDesc}>Optional</Typography>
                            </StepLabel>
                        </StepButton>
                        <StepContent className={props.classes.stepContent}>
                            <SampleProductsContainer
                                setStep={props.setStep}
                                setStepCompleted={props.setStepCompleted}
                            />
                        </StepContent>
                    </Step>
                    <Step>
                        <StepButton
                            className={props.classes.button}
                            onClick={() => props.setStep(2)}
                            completed={props.steps[2].completed}
                            disabled={props.activeStep === 2}
                        >
                            <StepLabel
                                classes={labelClasses}
                            >
                                Register / Login to SGL Fintech Account
                                <Typography className={props.classes.stepDesc}>Optional</Typography>
                            </StepLabel>
                        </StepButton>
                        <StepContent className={props.classes.stepContent}>
                            <RegisterContainer
                                setStep={props.setStep}
                                setStepCompleted={props.setStepCompleted}
                            />
                        </StepContent>
                    </Step>
                    <Step>
                        <StepButton
                            className={props.classes.button}
                            onClick={() => props.setStep(3)}
                            completed={props.steps[3].completed}
                            disabled={props.activeStep === 3 || !props.steps[2].completed}
                        >
                            <StepLabel
                                classes={labelClasses}
                            >
                                Applicant Details
                                <Typography className={props.classes.stepDesc}>Optional</Typography>
                            </StepLabel>
                        </StepButton>
                        <StepContent className={props.classes.stepContent}>
                            <ApplicantDetailsContainer
                                setStep={props.setStep}
                                setStepCompleted={props.setStepCompleted}
                            />
                        </StepContent>
                    </Step>
                    <Step>
                        <StepButton
                            className={props.classes.button}
                            onClick={() => props.setStep(4)}
                            completed={props.steps[4].completed}
                            disabled={(
                                props.activeStep === 4
                                || !props.steps[1].completed
                                || !props.steps[3].completed
                            )}
                        >
                            <StepLabel
                                classes={labelClasses}
                            >
                                Soft credit check
                                <Typography className={props.classes.stepDesc}>Optional</Typography>
                            </StepLabel>
                        </StepButton>
                        <StepContent className={props.classes.stepContent}>
                            <SoftCheckContainer
                                setStep={props.setStep}
                                setStepCompleted={props.setStepCompleted}
                                softCheckCompleted={props.steps[4].completed}
                            />
                        </StepContent>
                    </Step>
                    <Step>
                        <StepButton
                            className={props.classes.button}
                            onClick={() => props.setStep(5)}
                            completed={props.steps[5].completed}
                            disabled={props.activeStep === 5 || !props.steps[4].completed}
                        >
                            <StepLabel
                                classes={labelClasses}
                            >
                                Mortgage Calculation Summary
                                <Typography className={props.classes.stepDesc}>Optional</Typography>
                            </StepLabel>
                        </StepButton>
                        <StepContent className={props.classes.stepContent}>
                            <ApplicantDetailsSummaryContainer
                                setStep={props.setStep}
                                setStepCompleted={props.setStepCompleted}
                            />
                        </StepContent>
                    </Step>
                    <Step>
                        <StepButton
                            className={props.classes.button}
                            onClick={() => props.setStep(6)}
                            completed={props.steps[6].completed}
                            disabled={props.activeStep === 6 || !props.steps[3].completed}
                        >
                            <StepLabel
                                classes={labelClasses}
                            >
                                Applicant identity verification
                                <Typography className={props.classes.stepDesc}>Optional</Typography>
                            </StepLabel>
                        </StepButton>
                        <StepContent className={props.classes.stepContent}>
                            <ApplicantIdVerificationContainer
                                setStep={props.setStep}
                                setStepCompleted={props.setStepCompleted}
                            />
                        </StepContent>
                    </Step>
                    <Step>
                        <StepButton
                            className={props.classes.button}
                            onClick={() => props.setStep(7)}
                            completed={props.steps[7].completed}
                            disabled={props.activeStep === 7}
                        >
                            <StepLabel
                                classes={labelClasses}
                            >
                                Property details
                                <Typography className={props.classes.stepDesc}>Optional</Typography>
                            </StepLabel>
                        </StepButton>
                        <StepContent className={props.classes.stepContent}>
                            <PropertyDetailsContainer
                                setStep={props.setStep}
                                setStepCompleted={props.setStepCompleted}
                            />
                        </StepContent>
                    </Step>
                    <Step>
                        <StepButton
                            className={props.classes.button}
                            onClick={() => props.setStep(8)}
                            completed={props.steps[8].completed}
                            disabled={(
                                props.activeStep === 8
                                || !props.steps[4].completed
                                || !props.steps[6].completed
                                || !props.steps[7].completed
                            )}
                        >
                            <StepLabel
                                classes={labelClasses}
                            >
                                Select Best Offer
                                <Typography className={props.classes.stepDesc}>Optional</Typography>
                            </StepLabel>
                        </StepButton>
                        <StepContent className={props.classes.stepContent}>
                            <SelectBestOfferContainer
                                setStep={props.setStep}
                                setStepCompleted={props.setStepCompleted}
                            />
                        </StepContent>
                    </Step>
                    <Step>
                        <StepButton
                            className={props.classes.button}
                            onClick={() => props.setStep(9)}
                            completed={props.steps[9].completed}
                            disabled={props.activeStep === 9 || !props.steps[8].completed}
                        >
                            <StepLabel
                                classes={labelClasses}
                            >
                                Underwriting Summary
                                <Typography className={props.classes.stepDesc}>Optional</Typography>
                            </StepLabel>
                        </StepButton>
                        <StepContent className={props.classes.stepContent}>
                            <UnderWrittingSummaryContainer
                                setStep={props.setStep}
                                setStepCompleted={props.setStepCompleted}
                            />
                        </StepContent>
                    </Step>
                </Stepper>
                <DrawerContainer />
            </div>
        );
}

FormStepper.propTypes = {
    classes: PropTypes.object.isRequired,
    activeStep: PropTypes.number.isRequired,
    steps: PropTypes.array.isRequired,
    isPending: PropTypes.bool.isRequired,
    setStep: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    setStepsUncompleted: PropTypes.func.isRequired,
    setApplicationId: PropTypes.func.isRequired,
};

export default withStyles(styles)(FormStepper);



// WEBPACK FOOTER //
// ./src/app/FormStepper/FormStepper.js